import React from 'react';
import { FormattedMessage } from 'react-intl';
import Heading from '@atlaskit/heading';

export const Header = ({ createNeeded }: { createNeeded: boolean }) => {
  if (createNeeded) {
    return (
      <Heading size="small" as="h1">
        <FormattedMessage
          id="account.creation.confirmation.title"
          defaultMessage="Create your account"
          description="Title of form for creating an account"
        />
      </Heading>
    );
  } else {
    return (
      <Heading size="small" as="h1">
        <FormattedMessage
          id="account.verification.title"
          defaultMessage="Verify your email"
          description="Title of form for verifying an account"
        />
      </Heading>
    );
  }
};
